import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthDavesaV2Service } from '../auth-davesa-v2.service';
import { TokenType } from 'app/core/enum/token-type.enum';

/**
 * Password Expired Guard
 * 
 * For password-change route: Only allows access if user has temporary password expiration token
 * For other routes: Prevents access when password has expired and redirects to password change
 * 
 * Security: The password-change route is restricted to users with temporary tokens only.
 * This ensures that only users who logged in with expired passwords can access the page.
 * 
 * @example
 * {
 *   path: 'dashboard',
 *   canActivate: [isAuthDavesaGuard, PasswordExpiredGuard],
 *   component: DashboardComponent
 * }
 * 
 * @example
 * {
 *   path: 'password-change',
 *   canActivate: [PasswordExpiredGuard],
 *   component: PasswordChangeComponent
 * }
 */
export const PasswordExpiredGuard: CanActivateFn = (route, state) => {
  //TODO: tobe dicussed
  // const authService = inject(AuthDavesaV2Service);
  // const router = inject(Router);
  // const loginUserStatus = authService.loginUserStatus();
  // const isPasswordExpired = loginUserStatus?.passwordExpiresInDays <= 0;
  // const shouldShowWarning = !isPasswordExpired && loginUserStatus?.passwordExpiresInDays <= 7;

  // if (state.url.includes('/password-change')) {
  //   if (!shouldShowWarning && !isPasswordExpired) {
  //     if (!authService.check()) {
  //       return router.parseUrl('/sign-in');
  //     }
  //     return router.parseUrl('/dashboards/clinic');
  //   }
  //   return true;
  // }

  // if (isPasswordExpired) {
  //   return router.parseUrl('/password-change');
  // }
  return true;
};

